import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import { fetchAppicazione, fetchSiccurezza, fetchTrattamenti, fetchTrattamento } from "../../../features/produzione-trattamenti/produzione-trattamentiThunk";
// import tableData from "../../../utils/strucuture/SubTrattamentiData.json";
import { selectError, selectIsLoading } from "../../../features/produzione-trattamenti/produzione-trattamentiSlice";
import { useEffect } from "react";
import { fetchCompanies } from "../../../features/company/companyThunk";
const SubTrattamenti = () => {
    const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
    const columns = [
        { field: "tipo_di_trattamento", headerName: "Tipo di trattamento", width: 200 },
        { field: "idTerreno", headerName: "Produzione", width: 150 },
        { field: "idParcella", headerName: "ID di Produzione", width: 150 },
        { field: "date", headerName: "Data", width: 150 },
        { field: "product_used", headerName: "Prodotto utilizzato", width: 200 },
        { field: "pro_qty", headerName: "Q.ta prodotto", width: 150 },
        { field: "mod_di_applicazione", headerName: "Mod. applicazione", width: 200 },
        { field: "operatore_id", headerName: "Operatore Resp.", width: 200 },
        { field: "sicurezza", headerName: "Int. sicurezza (GG)", width: 200 },
        { field: "azioni", headerName: "Azioni", width: 100, sortable: false }
    ];
    const dispatch = useDispatch();
    const trattamentiData = useSelector((state) => state.produzioneTrattamenti.produzionetrattamenti);
    const isLoading = useSelector(selectIsLoading);
    const error = useSelector(selectError);
    useEffect(() => {
        dispatch(fetchCompanies())
    },[])
    useEffect(() => {
        dispatch(fetchTrattamenti());
        dispatch(fetchTrattamento())
        dispatch(fetchSiccurezza())
        dispatch(fetchAppicazione())
    }, [dispatch, selectSelectedCompany]);
    return (
        <>
            <div className="pageTemplate">
            <Table data={trattamentiData} columns={columns} navData={"subTrattamentiProduction"} deleteFunctions={"deleteProduzioneTrattamentiByID"} />
            </div>
        </>
    );
};

export default SubTrattamenti;